import 'normalize.css/normalize.css';
import 'babel-polyfill';
import {render} from 'react-dom';
import Routes from './routes';

// Catching unhandled exceptions natively 
window.addEventListener("unhandledrejection", err => {
    // Some browsers put the reason on event.reason, others under detail.reason
    const reason =
        (err && err.reason) ||
        (err && err.detail && err.detail.reason) ||
        err;
    // Surface but avoid crashing on undefined access
    throw reason;
});


render(Routes, document.getElementById('react-root'));
